// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"TZ-z","subtitle":"UZ-z","wrapper":"VZ-z","leftArrow":"WZ-z","rightArrow":"XZ-z"};